import { render, staticRenderFns } from "./SplitId.vue?vue&type=template&id=2ddfd5a0&scoped=true&"
import script from "./SplitId.vue?vue&type=script&lang=js&"
export * from "./SplitId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddfd5a0",
  null
  
)

export default component.exports